import { httpService } from '../../../../services/http.service';
import { BASE_URL, USER } from '../../../../constants/endpoints';
import bugsnagHandler from '../../../../services/bugsnag.service';

const { CONTROLLERS: { ADD_INVOICE_PAYMENT: { BASE: ADD_INVOICE_PAYMENT_BASE, VERSION: ADD_INVOICE_PAYMENT_VERSION } } } = USER;
const { CONTROLLERS: { MARK_AS_PAID: { BASE: MARK_AS_PAID_BASE, VERSION: MARK_AS_PAID_VERSION } } } = USER;

export const addInvoicePaymentAPIAction = async (customerId: string, externalId: string, payload: { amount: number, paymentTime: Date, paymentMethod: string }) => {
  if (!customerId || !externalId) {
    bugsnagHandler.notify('Invoice Hub - Add Invoice Payment Action - Missing customerId or externalId');
    return false;
  }
  try {
    const { data } = await httpService.put(`${BASE_URL}/api/${ADD_INVOICE_PAYMENT_VERSION}/${ADD_INVOICE_PAYMENT_BASE}/${customerId}/invoice/${externalId}/payment`, { ...payload });
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Invoice Hub - Add Invoice Payment Action - error adding invoice payment', e);
    throw e;
  }
};
export const markAsPaidAPIAction = async (customerId: string, externalId: string) => {
  if (!customerId || !externalId) {
    bugsnagHandler.notify('Invoice Hub - Mark as Paid Action - Missing customerId or externalId');
    return false;
  }
  try {
    const { data } = await httpService.post(`${BASE_URL}/api/${MARK_AS_PAID_VERSION}/${MARK_AS_PAID_BASE}/${customerId}/invoice/${externalId}/markAsPaid`);
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Invoice Hub - Mark as Paid Action - error marking invoice as paid', e);
    throw e;
  }
};
